// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__19U2Q","image":"Header_image__2RpcD","name":"Header_name__19sba","info":"Header_info__9W6iS","infoRow":"Header_infoRow__1GuWV"};